<template>
  <div class="location-platform-commission-levels">
    <div class="location-platform-commission-levels__hint">
      {{ $t('platformCommissionLevel.rangesHint') }}
    </div>

    <div
      v-for="(item, index) in items"
      :key="index"
      class="location-platform-commission-levels__level"
    >
      <div class="row">
        <div class="col-12 col-sm-4">
          <ui-input
            v-model="item.from"
            :label="fromLabel(index)"
            disabled
          />
        </div>
        <div
          v-if="isLatest(index)"
          class="col-12 col-sm-4"
        >
          <ui-input
            v-model="item.to"
            :label="$t('platformCommissionLevel.toMax', { currency: currencyLabel })"
            disabled
          />
        </div>
        <validation-provider
          v-else
          tag="div"
          class="col-12 col-sm-4"
          :name="`${$t('platformCommissionLevel.to', { currency: currencyLabel })}_${index}`"
          :rules="toRules(index)"
          mode="passive"
          v-slot="{ errors }"
        >
          <ui-input
            v-model="item.to"
            :label="$t('platformCommissionLevel.to', { currency: currencyLabel })"
            required
            :error="errors[0]"
            @input="onChangeTo(item, index)"
          />
        </validation-provider>
        <validation-provider
          tag="div"
          class="col-12 col-sm-4"
          :name="`${$t('platformCommissionLevel.fee')}_${index}`"
          rules="required|decimal|max_value:100"
          mode="passive"
          v-slot="{ errors }"
        >
          <ui-input
            v-model="item.fee"
            :label="$t('platformCommissionLevel.fee')"
            required
            :error="errors[0]"
          />
        </validation-provider>
      </div>
      <div
        v-if="rangeDescription(item, index)"
        class="location-platform-commission-levels__description"
      >
        {{ rangeDescription(item, index) }}
      </div>
    </div>
  </div>
</template>

<script>
import { isNil } from 'lodash';

export default {
  name: 'LocationPlatformCommissionLevels',

  props: {
    items: {
      type: Array,
      required: true,
    },
    maxTipsAmount: {
      type: [Number, String],
      default: null,
    },
    currencyLabel: {
      type: String,
      required: true,
    },
  },

  methods: {
    isLatest(index) {
      return index === this.items.length - 1;
    },
    isFilled(value) {
      return !isNil(value) && value !== '';
    },
    toRules(index) {
      const rules = {
        required: true,
        decimal: true,
        greater_than: index > 0 ? this.items[index - 1].to : 0,
      };

      if (index === this.items.length - 2) {
        rules.less_than = this.maxTipsAmount;
      }

      return rules;
    },
    fromLabel(index) {
      return index === 0
        ? this.$t('platformCommissionLevel.from', { currency: this.currencyLabel })
        : this.$t('platformCommissionLevel.over', { currency: this.currencyLabel });
    },
    rangeDescription(item, index) {
      if (!this.isFilled(item.to) || !this.isFilled(item.fee) || (index > 0 && !this.isFilled(item.from))) {
        return '';
      }

      const params = {
        from: item.from,
        to: item.to,
        fee: item.fee,
        currency: this.currencyLabel,
      };

      return index === 0
        ? this.$t('platformCommissionLevel.firstRangeDescription', params)
        : this.$t('platformCommissionLevel.rangeDescription', params);
    },
    onChangeTo(item, index) {
      if (index < this.items.length - 1) {
        this.items[index + 1].from = item.to;
      }
    },
  },
};
</script>

<style lang="scss">
.location-platform-commission-levels {
  padding-bottom: 12px;

  &__hint {
    margin-top: -12px;
    margin-bottom: 4px;
    font-size: 12px;
    line-height: 16px;
    color: #777777;
  }

  &__level {
    margin-bottom: 12px;
  }

  .design &__level .form-group {
    margin-top: 24px;
    margin-bottom: 0;
  }

  &__description {
    margin-top: 6px;
    font-size: 12px;
    line-height: 16px;
    color: #777777;
  }
}
</style>
